
/**
 * this helper return an array of integers listed from 1 to total pages
 * @param totalPages
 * @returns
 */
export const buildPagesNumbers = (totalPages: number) => {
  return Array.from({ length: totalPages }, (_, index) => index + 1);
};

/**
 *
 * @param obj
 * @param key
 * @returns
 */
export const getNestedValue = (obj: any, key: string, t) => {
  return key.split(".").reduce((acc, currentKey) => {
    if (acc && typeof acc === "object") {
      const value = acc[currentKey];
      if (currentKey === "gender" && value) {
        // Create a new object with the updated 'gender' property
        return t("common.gender." + value);
      }
      if (currentKey === "medicalCover") {
        return t(
          "forms.medicalCover." + value?.toUpperCase().replace(/ /g, "_")
        );
      }
      if (currentKey === "status") {
        return t("common.status." + value);
      }
      if (currentKey === "name" && key?.includes("speciality")) {
        return  value
      }
      return value;
    }
    return undefined;
  }, obj);
};
